const GA_MEASUREMENT_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;

let isInitialized = false;

export function initGoogleAnalytics() {
  if (typeof window === "undefined") return;
  if (!GA_MEASUREMENT_ID) return;
  if (isInitialized) return;

  isInitialized = true;

  // Avoid injecting the script multiple times
  const existingScript = document.querySelector(
    `script[data-ga-measurement-id="${GA_MEASUREMENT_ID}"]`
  );
  if (!existingScript) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.dataset.gaMeasurementId = GA_MEASUREMENT_ID;
    document.head.appendChild(script);
  }

  // GA4 recommended snippet: define dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  // Only define gtag once
  if (!window.gtag) {
    window.gtag = gtag;
  }

  window.gtag("js", new Date());

  // Disable automatic page_view so we can control SPA page views explicitly
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackGoogleAnalyticsPageView(path) {
  if (typeof window === "undefined") return;
  if (!GA_MEASUREMENT_ID) return;
  if (!window.gtag) return;

  window.gtag("event", "page_view", {
    page_path: path,
  });
}

export function trackGoogleAnalyticsEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (!GA_MEASUREMENT_ID) return;
  if (!window.gtag) return;

  window.gtag("event", name, params);
}

